import { tv } from '@/libs/tv'

type ColumnMeta = {
	headerLabel: string
	className?: string
	headerClassName?: string
	sticky?: boolean
}

const tableHead = tv({
	base: 'border-b-0 px-4 py-3 flex items-center h-full relative',
	variants: {
		sticky: {
			true: 'md:sticky border-r-0 md:left-0 bg-background z-10',
		},
	},
})

const tableCell = tv({
	base: 'px-4 h-full flex items-center border-b border-border overflow-hidden',
	variants: {
		sticky: {
			true: 'md:sticky md:left-0 bg-background group-hover:bg-hover-group z-10',
		},
		variant: {
			name: ['border-r-0'],
		},
	},
})

const stickyNameClass = [
	'before:absolute before:right-0 before:top-0 before:bottom-0 before:w-px before:bg-border',
	'after:absolute after:right-[-24px] after:top-0 after:bottom-0 after:w-6 after:bg-gradient-to-l after:from-transparent after:to-background after:z-[-1]',
].join(' ')

const stickyNameCellClass = [stickyNameClass, 'group-hover:after:opacity-0'].join(' ')

const actionsColumnBase = {
	id: 'actions',
	header: 'Actions',
	size: 100,
	minSize: 100,
	maxSize: 120,
	enableResizing: false,
	enableSorting: false,
	enableHiding: false,
	meta: {
		headerLabel: 'Actions',
		headerClassName: [
			'sticky right-0 bg-background z-10 justify-center',
			'before:absolute before:left-0 before:top-0 before:bottom-0 before:w-px before:bg-border',
			'after:absolute after:left-[-24px] after:top-0 after:bottom-0 after:w-6 after:bg-gradient-to-r after:from-transparent after:to-background after:z-[-1]',
		].join(' '),
		className: [
			'sticky right-0 bg-background group-hover:bg-hover-group  z-20 justify-center',
			'before:absolute before:left-0 before:top-0 before:bottom-0 before:w-px before:bg-border',
			'after:absolute after:left-[-24px] after:top-0 after:bottom-0 after:w-6 after:bg-gradient-to-r after:from-transparent after:to-background group-hover:after:opacity-0 after:z-[-1]',
		].join(' '),
	} satisfies ColumnMeta,
} as const

export { tableHead, tableCell, actionsColumnBase, stickyNameClass, stickyNameCellClass }
export type { ColumnMeta }
